import { render, staticRenderFns } from "./WhatsappTab.vue?vue&type=template&id=1d4b9031"
import script from "./WhatsappTab.vue?vue&type=script&lang=js"
export * from "./WhatsappTab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports